import { render, staticRenderFns } from "./AppointmentReasonList.vue?vue&type=template&id=2355f2cd&"
import script from "./AppointmentReasonList.vue?vue&type=script&lang=js&"
export * from "./AppointmentReasonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports